import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './index.css';

const ConfirmChequeModal = ({ isOpen, toggle, handleSubmit }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="AcceptOrderConfirmModal"
    >
      <ModalHeader>
      Confirm Physical Cheques Details
      </ModalHeader>
      <ModalBody>
      <div className="bodyArea" style={{fontSize:'17px'}}>
      Are you sure want to confirm the physical cheque details ?
      </div>
      </ModalBody>
      <ModalFooter>
        <button className="customButton" onClick={toggle}>
          No
        </button>
        <button
          className="customButton customButton_blue"
          onClick={handleSubmit}
        >
          Yes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmChequeModal;
